<template>
    <div>

        <Head title="Ticket" />
        <h1 class="mb-8 text-3xl font-bold">Tickets Reports</h1>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <!-- <label class="block text-gray-700">Department:</label>
                  <select v-model="form.department" class="form-select mt-1 w-full">
                      <option :value="null" />
                      <option v-for="dp in departments" :key="dp.index" :value="dp.name">{{ dp.name }}</option>
                  </select> -->
                <label class="block mt-4 text-gray-700">Trashed:</label>
                <select v-model="form.trashed" class="form-select mt-1 w-full">
                    <option :value="null" />
                    <option value="with">With Trashed</option>
                    <option value="only">Only Trashed</option>
                </select>
            </search-filter>
            <date-picker label="From" v-model="form.from" class="pr-6 ml-auto" />
            <date-picker label="To" v-model="form.to" class="pr-6 " />
            <filter-drop-down class="mr-4" filterName="Status">
                <label class="block text-gray-700">Status:</label>
                <select v-model="form.status" class="form-select mt-1">
                    <option :value="null">All</option>
                    <option v-for="st in status" :key="st.id" :value="st.name">{{ st.name }}</option>
                </select>
            </filter-drop-down>
            <filter-drop-down class="mr-4" filterName="Departments">
                <label class="block text-gray-700">Department:</label>
                <select v-model="form.department" class="form-select mt-1">
                    <option :value="null">All</option>
                    <option v-for="dp in departments" :key="dp.id" :value="dp.name">{{ dp.name }}</option>
                </select>
            </filter-drop-down>
            <download-excel class="btn-indigo cursor-pointer hover:cursor-pointer" :fields="json_fields" :data="tickets.data" type="xlsx" :name="`tickets-reports-${getCurrentFormattedDate()}.xls`">
                Download
            </download-excel>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Subject</th>
                    <th class="pb-4 pt-6 px-6">Created By</th>
                    <th class="pb-4 pt-6 px-6">Issue</th>
                    <th class="pb-4 pt-6 px-6">Status</th>
                    <th class="pb-4 pt-6 px-6">Department</th>
                </tr>
                <tr v-for="ticket in tickets.data" :key="ticket.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4 focus:text-indigo-500 font-medium" tabindex="-1">
                        {{ ticket.summary }}
                        <icon v-if="ticket.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                        <div v-if="ticket.user">{{ ticket.user.first_name }} {{ ticket.user.last_name }}</div>
                        {{ ticket.created_by }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                        <div v-if="ticket.issue">{{ ticket.issue.name }}</div>
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                        {{ capitalisedFirstLetter(ticket.status) }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link class="flex items-center px-6 py-4" tabindex="-1">
                        <div v-if="ticket.department">{{ ticket.department.name }}</div>
                        </Link>
                    </td>

                </tr>
                <tr v-if="tickets.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="6">No tickets found.</td>
                </tr>
            </table>
        </div>
    </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import RoleChecker from '../../../Shared/Helpers/RoleChecker'
import Dropdown from '@/Shared/Dropdown'
import DatePicker from '@/Shared/DatePicker'
import FilterDropDown from '@/Shared/FilterDropDown'
import JsonExcel from "vue-json-excel3";


export default {
    components: {
        Head,
        Icon,
        Link,
        SearchFilter,
        RoleChecker,
        Dropdown,
        FilterDropDown,
        DatePicker,
        "downloadExcel": JsonExcel,
    },
    layout: Layout,
    props: {
        filters: Object,
        tickets: Object,
        departments: Array,
        status: Array,
    },
    data() {
        return {
            form: {
                search: this.filters.search,
                status: this.filters.status,
                trashed: this.filters.trashed,
                department: this.filters.department,
                from: this.filters.from,
                to: this.filters.to
            },
            maxWidth: 300,
            json_fields: {
                "Summary": "summary",
                "Description": "description",
                "Issue": "issue.name",
                "Status": "status",
                "Department": "department.name",
                "Created By": {
                    field: "user", callback: (value) => {
                        return value.first_name + " " + value.last_name
                    },
                }
            },
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get('/reports/tickets', pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        hasRole(role) {
            var userRole = new RoleChecker(this.$page.props)
            return userRole.hasRole(role)
        },

        getCurrentFormattedDate() {
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const day = String(currentDate.getDate()).padStart(2, '0');
            const hours = String(currentDate.getHours()).padStart(2, '0');
            const minutes = String(currentDate.getMinutes()).padStart(2, '0');
            const seconds = String(currentDate.getSeconds()).padStart(2, '0');

            const formattedDate = `${year}_${month}_${day}_${hours}${minutes}${seconds}`;

            return formattedDate;
        },

        capitalisedFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        },

        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
  